import { NavLink, Outlet, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { pmApi } from '../api/pm.js';
import AppHeader from './layout/AppHeader.jsx';

export default function PmShell() {
  const { key } = useParams();
  const [project, setProject] = useState(null);

  // `:key` is a PROJECT key under /pm/projects/:key/* but an ISSUE key under
  // /pm/issues/:key ("BOS-1"), and both nest in this shell. Strip a trailing
  // issue number so the shell resolves the owning project instead of firing
  // GET /projects/BOS-1 and 404ing on every issue detail page.
  const projectKey = key ? key.replace(/-\d+$/, '') : null;

  useEffect(() => {
    if (projectKey) pmApi.getProject(projectKey).then((d) => setProject(d?.project)).catch(() => setProject(null));
    else setProject(null);
  }, [projectKey]);

  return (
    <div className="hr-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Projects</div>
          <ul>
            <li><NavLink to="/pm/projects" end className={({ isActive }) => isActive ? 'active' : ''}>All projects</NavLink></li>
            <li><NavLink to="/pm/qa" className={({ isActive }) => isActive ? 'active' : ''}>QA Dashboard</NavLink></li>
            <li><NavLink to="/pm/releases" className={({ isActive }) => isActive ? 'active' : ''}>Releases</NavLink></li>
          </ul>
          {project && (
            <>
              <div className="hr-side-title" style={{ marginTop: 18 }}>{project.key}</div>
              <ul>
                <li><NavLink to={`/pm/projects/${project.key}/board`} className={({ isActive }) => isActive ? 'active' : ''}>Board</NavLink></li>
                <li><NavLink to={`/pm/projects/${project.key}/backlog`} className={({ isActive }) => isActive ? 'active' : ''}>Backlog</NavLink></li>
                <li><NavLink to={`/pm/projects/${project.key}/roadmap`} className={({ isActive }) => isActive ? 'active' : ''}>Roadmap</NavLink></li>
                <li><NavLink to={`/pm/projects/${project.key}/timeline`} className={({ isActive }) => isActive ? 'active' : ''}>Timeline</NavLink></li>
                <li><NavLink to={`/pm/projects/${project.key}/sprints`} className={({ isActive }) => isActive ? 'active' : ''}>Sprints</NavLink></li>
                <li><NavLink to={`/pm/projects/${project.key}/qa`} className={({ isActive }) => isActive ? 'active' : ''}>QA</NavLink></li>
                <li><NavLink to={`/pm/projects/${project.key}/releases`} className={({ isActive }) => isActive ? 'active' : ''}>Releases</NavLink></li>
                <li><NavLink to={`/pm/projects/${project.key}/settings`} className={({ isActive }) => isActive ? 'active' : ''}>Settings</NavLink></li>
              </ul>
            </>
          )}
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
